export enum BaseDataReferenceCareType {
  RESIDENT_NUMBER = 'residentNumber',
  GENDER = 'gender',
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  ROOM = 'room',
  STATION = 'station',
  LIVING_AREA = 'livingArea',
  CARE_LEVEL = 'careLevel',
  REFERENCE_CARE_1 = 'referenceCare1Name',
  REFERENCE_CARE_2 = 'referenceCare2Name',
  REFERENCE_CARE_3 = 'referenceCare3Name',
  SOCIAL_CARE_REFERENCE = 'socialCareReferenceName',
  LAST_VISIT = 'lastVisit',
  DUE_DATE = 'dueDate',
  FILLED_OUT_AT = 'filledOutAt',
  CHECKED_AT = 'checkedAt',
  NOTES = 'notes',
}
